<template>
    <div class="vp-toolbar">
      <div class="vp-toolbar-left">
        <button class="vp-vlc-button" type="button" title="播放" aria-disabled="false" @click="handleAction(playState)">
          <span :class="['vp-icon-placeholder', playState]" aria-hidden="true"></span>
        </button>
      </div>
      <div class="vp-toolbar-right">
        <button class="vp-vlc-button" type="button" title="全屏" aria-disabled="false" @click="handleAction(fullscreenState)">
          <span :class="['vp-icon-placeholder', fullscreenState]" aria-hidden="true"></span>
        </button>
      </div>
    </div>
</template>

<script>
import { EventBus } from '../../utils/eventbus';
import { Action } from "./action";
export default {
  data() {
    return {
      playState: '',
      fullscreenState: '',
    }
  },
  mounted() {
    EventBus.$on('toolbar', this.handleStateChange)
  },
  beforeDestroy() {
    EventBus.$off('toolbar', this.handleStateChange)
  },
  methods: {
    handleAction(val) {
      this.$emit('action', Action[val])
    },
    handleStateChange(val) {
      const PlayState = [Action.play, Action.pause];
      const FullscreenState = [Action.fullscreen, Action.exitFullscreen];
      if (PlayState.indexOf(val) > -1) {
        this.playState = val
      } else if (FullscreenState.indexOf(val) > -1) {
        this.fullscreenState = val;
      }
    }
  }
}
</script>

<style>

</style>